import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SkuSearchUiModule } from '@emi/sku-search/ui';
import { SkuTimeSeriesComponent } from './sku-time-series.component';
import { SkuTimeSeriesTopBarComponent } from './sku-time-series-top-bar/sku-time-series-top-bar.component';
import { SkuTimeSeriesFilterBarComponent } from './sku-time-series-filter-bar/sku-time-series-filter-bar.component';
import { SkuTimeSeriesTableComponent } from './sku-time-series-table/sku-time-series-table.component';
import { SkuTimeSeriesTableGroupComponent } from './sku-time-series-table/sku-time-series-table-group/sku-time-series-table-group.component';
import { SkuTimeSeriesTableRowComponent } from './sku-time-series-table/sku-time-series-table-row/sku-time-series-table-row.component';
import { SharedUiModule } from '@emi/shared/ui';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { ExchangeRateModal } from './exchange-rate-modal/exchange-rate-modal.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SkuSearchUiModule,
        MatDatepickerModule,
        MatFormFieldModule,
        SharedUiModule,
        MatSelectModule,
        MatRadioModule,
        MatCheckboxModule,
        MatButtonModule,
        MatTooltipModule,
        InfiniteScrollModule
    ],
    declarations: [
        SkuTimeSeriesComponent,
        SkuTimeSeriesTopBarComponent,
        SkuTimeSeriesFilterBarComponent,
        SkuTimeSeriesTableComponent,
        SkuTimeSeriesTableGroupComponent,
        SkuTimeSeriesTableRowComponent,
        ExchangeRateModal,
    ],
    exports: [
        SkuTimeSeriesComponent,
        SkuTimeSeriesTopBarComponent,
        SkuTimeSeriesFilterBarComponent,
        SkuTimeSeriesTableComponent,
        SkuTimeSeriesTableGroupComponent,
        SkuTimeSeriesTableRowComponent,
        ExchangeRateModal,
    ],
})
export class SkuTimeSeriesModule {}
